import * as React from 'react';
import { RequestDemandBlock } from '../../../components/RequestDemand/components/RequestDemandBlock';
import * as RealtorImage from '../../../components/RequestDemand/assets/offer-request-rieltor.png';
import { ModalWindow } from '@cian/ui-kit/modal';
import { RequestDemandBanner } from '../../../components/RequestDemand/components/RequestDemandBanner';
import { getModalContent } from './getModalContent';
import { EDemandDisplayMode } from './demandDisplayMode';
import { ElementInViewport } from '../../../common/components/elementInViewport';

export interface IRealtorDemandProps {
  text: string;
  isDemandRequestOpen: boolean;
  isSuccessModalOpen: boolean;
  isSmsVerificationModalOpen: boolean;
  displayMode?: EDemandDisplayMode;

  openDemandRequest(): void;

  closeDemandRequest(): void;

  onShownInViewPort(visible: boolean): void;
}

export const RealtorDemand: React.FC<IRealtorDemandProps> = ({
  text,
  openDemandRequest,
  isDemandRequestOpen,
  isSuccessModalOpen,
  closeDemandRequest,
  isSmsVerificationModalOpen,
  onShownInViewPort,
  displayMode = EDemandDisplayMode.CARD,
}) => {
  const DemandComponent = React.useMemo(
    () => (displayMode === EDemandDisplayMode.CARD ? RequestDemandBlock : RequestDemandBanner),
    [displayMode],
  );

  const [hasBlockShown, setHasBlockShown] = React.useState(false);

  const handleShown = React.useCallback(() => {
    if (hasBlockShown) {
      return;
    }
    setHasBlockShown(true);
    onShownInViewPort(true);
  }, [hasBlockShown]);

  return (
    <ElementInViewport onChange={handleShown}>
      <DemandComponent
        title="Помощь риелтора"
        buttonAction={openDemandRequest}
        buttonText="Оставить заявку"
        image={RealtorImage}
        text={text}
      />
      <ModalWindow
        open={isDemandRequestOpen}
        onClose={closeDemandRequest}
        size="XS"
        width={448}
        {...getModalContent(isSmsVerificationModalOpen, isSuccessModalOpen)}
      />
    </ElementInViewport>
  );
};

RealtorDemand.displayName = 'RealtorDemand';
